export const messages = {
  en: {
    chooseProduct: {
      title: 'Choose Product',
      search: 'Search',
      searchPlaceholder: 'Please enter product name or code',
      productName: 'Product Name',
      productCode: 'Product Code',
      price: 'Price',
      stock: 'Stock',
      category: 'Category',
      confirm: 'Confirm',
      cancel: 'Cancel',
      noData: 'No data available'
    }
  },
  zh: {
    chooseProduct: {
      title: '选择商品',
      search: '搜索',
      searchPlaceholder: '请输入商品名称或编码',
      productName: '商品名称',
      productCode: '商品编码',
      price: '价格',
      stock: '库存',
      category: '分类',
      confirm: '确认',
      cancel: '取消',
      noData: '暂无数据'
    }
  }
} 